import React from 'react'
import PropTypes from 'prop-types'

const InfoGraphicCounter = (props) => {
    return (
        <div className='info-graphic-counter'>
            <div className='icon-wrap'>
                <img src={`/images/${props.icon}`} alt='Blocked viruses' />
            </div>
            <div className='count-wrap'>
                <div className='count mb-2'><span>{props.count}</span></div>
                <p className='m-0 color-indigo'>{props.title}</p>
            </div>

        </div>
    )
}

InfoGraphicCounter.propTypes = {
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired
}

export default InfoGraphicCounter



// WEBPACK FOOTER //
// ./resources/js/components/InfoGraphicCounter.js